import Logo from "components/Home/Logo/Logo";
import React, { useState } from "react";
import { logo3 } from "utils/images";
import { logo2 } from "utils/images";
import { logo1 } from "utils/images";

export default function MiscInvoiceModal({ data, close }) {
  const {
    supplier_id,
    sales_agents,
    invoice_details,
    amount,
    invoice_number,
    customer_details,
    created_at,
  } = data;

  return (
    <>
      {/* Global print CSS to remove scrollbars and minimize spacing */}
      <style>{`
  @media print {
    /* Hide everything by default */
    body * {
      visibility: hidden;
      font-family: Arial, sans-serif;
    }
    /* Make the invoice content visible */
    #invoice-content, #invoice-content * {
      visibility: visible;
    }
    /* Fix header and footer so they repeat on every page */
    #invoice-header, #invoice-footer {
      position: fixed;
      left: 0;
      right: 0;
    }
    #invoice-header {
      top: 0;
      /* set a height if needed */
      height: 190px;
    }
    #invoice-footer{
      position: absolute;
      bottom: 0px;
    }
    /* Make sure the body has top and bottom margins to avoid overlap */
    #invoice-body {
      margin-top: 150px;  /* slightly more than header height */
      margin-bottom: 60px; /* slightly more than footer height */
    }
    @page {
      margin: 0 !important;
    }
    html, body {
      margin: 0 !important;
      padding: 0 !important;
      overflow: visible !important;
    }
    /* Other print adjustments as before */
    * {
      overflow: visible !important;
      -ms-overflow-style: none !important;
      scrollbar-width: none !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    ::-webkit-scrollbar {
      display: none !important;
    }
    .overflow-x-auto {
      overflow: visible !important;
    }
    .no-print {
      display: none !important;
    }
    .modal, .modal-box {
      margin: 0 !important;
      padding: 0 !important;
      box-shadow: none !important;
      border: none !important;
    }
  }
`}</style>

      <div className="modal modal-open">
        <div
          className="modal-box relative h-screen max-h-full w-screen max-w-full rounded-none bg-white p-0 text-black shadow-xl"
          id="invoice-content"
        >
          {/* Header Section */}
          <div
            id="invoice-header"
            className="bg-gradient-to-r from-blue-900 to-blue-500 p-10 text-white"
          >
            <div className="flex items-center justify-between">
              <div>
                <Logo
                  logo1={logo1}
                  logo2={logo2}
                  logo3={logo3}
                  width={{
                    logo1: "w-16",
                    logo2: "w-60 mt-1",
                    logo3: "w-40 mt-1",
                  }}
                />
              </div>

              <div className="text-md text-right">
                <p className="">Invoice No: {invoice_number}</p>
                <p className="">
                  Invoice Date: {new Date(created_at).toLocaleDateString()}
                </p>

                <p className="">Client No: {customer_details.phone_number}</p>
                <p className="">TICO REGISTRATION NO.: 12345 (RETAIL)</p>
                <p className="">TICO REGISTRATION NO.: 12345 (WHOLESALE)</p>
                {/* Wrap supplier view toggle in no-print */}
              </div>
            </div>
          </div>

          <div id="invoice-body" className="p-10">
            <div className="border-b-2 border-blue-200 px-2 py-2">
              <div className="grid grid-cols-3 text-lg">
                <div className="col-span-1">
                  <p className="text-lg font-semibold">Bill To:</p>
                  {customer_details && (
                    <div className="">
                      {customer_details.full_name && (
                        <p>{customer_details.full_name}</p>
                      )}
                      {customer_details.address && (
                        <p>{customer_details.address}</p>
                      )}
                      {(customer_details.city_name ||
                        customer_details.state_name ||
                        customer_details.postal_code) && (
                        <p>
                          {customer_details.city_name}
                          {customer_details.city_name &&
                            (customer_details.state_name ||
                              customer_details.postal_code) &&
                            ", "}
                          {customer_details.state_name}
                          {customer_details.state_name &&
                            customer_details.postal_code &&
                            ", "}
                          {customer_details.postal_code}
                        </p>
                      )}
                      {customer_details.country_name && (
                        <p>{customer_details.country_name}</p>
                      )}
                      {customer_details.passport_number && (
                        <p>
                          <span>Passport number: </span>
                          {customer_details.passport_number}
                        </p>
                      )}
                    </div>
                  )}
                </div>
                <div className="col-span-2">
                  <div className="grid grid-cols-2">
                    <div>
                      <p className="font-semibold">Created Date</p>
                      <p className="text-lg">
                        {created_at && created_at.split("T")[0]}
                      </p>
                    </div>

                    <div>
                      <p className="font-semibold">Booking Agent</p>
                      <p className="text-lg">{sales_agents?.name}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="overflow-hidden bg-white py-6">
              <div className="grid grid-cols-2 items-center justify-center gap-4">
                <div className="rounded-md bg-pink-50 p-4 shadow-sm">
                  <h2 className="font-semibold uppercase tracking-wide ">
                    Supplier
                  </h2>
                  <p className="mt-1 text-lg text-gray-800">{supplier_id}</p>
                </div>
                <div className="rounded-md bg-blue-50 p-4 shadow-sm">
                  <h2 className="font-semibold uppercase tracking-wide ">
                    Amount
                  </h2>
                  <p className="mt-1 text-lg text-gray-800">{amount}</p>
                </div>
              </div>
              <div className="mt-6">
                <h2 className="text-lg font-semibold ">Invoice Details</h2>
                <p className="mt-2 ">{invoice_details}</p>
              </div>
            </div>

            {/* Print Button */}
            <div className="no-print p-6 text-center">
              <button
                className="btn btn-primary"
                onClick={() => window.print()}
              >
                Print Invoice
              </button>
            </div>
          </div>

          {/* Footer */}
          <div id="invoice-footer" className="text-center text-sm">
            <Logo
              logo3={logo3}
              width={{
                logo3: "w-60 mb-2 mt-1",
              }}
            />
            <div className="bg-gray-100 p-4">
              <p className="text-black">
                2883 Derry Rd E, Mississauga, ON L4T 1A6, Canada
              </p>
              <p className="text-black">
                Contact: support@katariatravel.ca | Tel: 905 678 1200 | Fax: 905
                678 1201
              </p>
            </div>
          </div>

          {/* Close Button */}
          <button
            className="no-print hover-text-white btn btn-circle btn-sm absolute left-6 top-6 border border-red-500 bg-white text-lg text-red-500 hover:bg-red-500 hover:text-white"
            onClick={close}
          >
            {"<"}
          </button>
        </div>
      </div>
    </>
  );
}
